export default [
  {
    path: '/db/movies-old',
    name: 'movies-old',
    component: () => import('@/views/database/MoviesList.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies',
    name: 'movies',
    component: () => import('@/views/database/MoviesTable.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movie/:id/edit',
    name: 'movie-edit',
    component: () => import('@/views/database/MovieEdit.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movie/:id',
    name: 'movie-view',
    component: () => import('@/views/database/MovieDetail.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/people/:id',
    name: 'person-view',
    component: () => import('@/views/database/PersonDetail.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/franchise/:id',
    name: 'franchise-view',
    component: () => import('@/views/database/FranchiseDetail.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies/premiers',
    name: 'movies-premiers',
    component: () => import('@/views/database/MoviesPremiers.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies/top',
    name: 'movies-top',
    component: () => import('@/views/database/MoviesTop.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies/filter',
    name: 'movies-filter',
    component: () => import('@/views/database/MoviesFilter.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies/search',
    name: 'movies-search',
    component: () => import('@/views/database/MoviesSearch.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies/kinopub',
    name: 'movies-kinopub',
    component: () => import('@/views/database/import/FileList.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies/kinopub/import/:filename',
    name: 'movies-kinopub-import',
    component: () => import('@/views/database/import/ImportFile.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies/collections',
    name: 'movies-collections',
    component: () => import('@/views/database/import/KpCollectionsList.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/movies/collection/import/:slug',
    name: 'movies-collection-import',
    component: () => import('@/views/database/import/ImportCollection.vue'),
    meta: {
      resource: 'db-movies',
      action: 'view',
    },
  },
  {
    path: '/db/music-dashboard',
    name: 'music-dashboard',
    component: () => import('@/views/db-music/MusicDashboard.vue'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/artists',
    name: 'artists',
    component: () => import('@/views/db-music/ArtistsList.vue'),
    meta: {
      resource: 'artist-list',
      action: 'view',
    },
  },
  {
    path: '/db/artists/search',
    name: 'artists-search',
    component: () => import('@/views/db-music/ArtistsSearch.vue'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/artist/:id',
    name: 'artist-view',
    component: () => import('@/views/db-music/ArtistDetail.vue'),
    meta: {
      resource: 'artist',
      action: 'view',
    },
  },
  {
    path: '/db/fresh-releases',
    name: 'fresh-releases',
    component: () => import('@/views/db-music/FreshReleases.vue'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/track/:id',
    name: 'track-detail',
    component: () => import('@/views/db-music/TrackDetail.vue'),
    meta: {
      resource: 'track-view',
      action: 'view',
    },
  },
  {
    path: '/db/track/:id/search',
    redirect: to => ({ name: 'track-detail', params: { id: to.params.id } }),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/track/:id/covers',
    redirect: to => ({ name: 'track-detail', params: { id: to.params.id }, query: { tab: 'covers' } }),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/tracks',
    name: 'tracks',
    component: () => import('@/views/db-music/TracksList.vue'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/tracks/missing',
    name: 'tracks-missing',
    component: () => import('@/views/db-music/MissingTracks.vue'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/tracks/orphans',
    name: 'tracks-orphans',
    component: () => import('@/views/db-music/OrphanTracks.vue'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/autotopics',
    name: 'autotopics',
    component: () => import('@/views/topics/TopicsList'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/lists',
    name: 'lists',
    component: () => import('@/views/topics/ListsList'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/lists/:id',
    name: 'list-view',
    component: () => import('@/views/topics/ListView'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/import',
    name: 'music-import',
    component: () => import('@/views/db-music/MusicImport'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/playlist-search',
    redirect: { name: 'music-import' },
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/yandex-feed',
    name: 'yandex-feed',
    component: () => import('@/views/db-music/YandexFeed'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/packs-search',
    name: 'packs-search',
    component: () => import('@/views/db-music/PacksSearch'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/pack-analyze',
    name: 'pack-analyze',
    component: () => import('@/views/db-music/PackAnalyze'),
    meta: {
      resource: 'pack-review',
      action: 'view',
    },
  },
  {
    path: '/db/pack-validate',
    name: 'pack-validate',
    component: () => import('@/views/db-music/PackValidate'),
    meta: {
      resource: 'pack-review',
      action: 'view',
    },
  },
  {
    path: '/db/pack-shazam-check',
    name: 'pack-shazam-check',
    component: () => import('@/views/db-music/PackShazamCheck'),
    meta: {
      resource: 'pack-review',
      action: 'view',
    },
  },
  {
    path: '/db/pack-antishazam',
    name: 'pack-antishazam',
    component: () => import('@/views/db-music/PackAntishazam'),
    meta: {
      resource: 'db-music',
      action: 'manage',
    },
  },
  {
    path: '/db/pack-from-files',
    name: 'pack-from-files',
    component: () => import('@/views/db-music/PackFromFiles'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/kworb-chart',
    name: 'kworb-chart',
    component: () => import('@/views/db-music/KworbChart'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/charts',
    name: 'charts-view',
    component: () => import('@/views/db-music/charts/ChartsView.vue'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/covers-search',
    name: 'covers-search',
    component: () => import('@/views/db-music/CoversSearch'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/:streaming/playlist/:owner_id/:id',
    name: 'yandex-playlist-view',
    component: () => import('@/views/db-music/PlaylistView'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
  {
    path: '/db/:streaming/playlist/:id',
    name: 'spotify-playlist-view',
    component: () => import('@/views/db-music/PlaylistView'),
    meta: {
      resource: 'db-music',
      action: 'view',
    },
  },
]
